import { Icon, IconButton, Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef, GridToolbar } from '@mui/x-data-grid-pro';
import React from 'react';

import { GeneralConstants } from 'app/constants';
import { history } from 'app/history';
import { PartnerMapUnion } from 'app/model';

interface PartnerMapGridProps extends Omit<DataGridProProps, 'columns'> {
    rows: PartnerMapUnion[];
}

export const PartnerMapGrid: React.FunctionComponent<PartnerMapGridProps> = (props) => (
    <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
        <DataGridPro
            density='compact'
            pagination
            pageSizeOptions={GeneralConstants.PAGE_SIZE_OPTIONS}
            components={{ Toolbar: GridToolbar }}
            initialState={{
                columns: {
                    columnVisibilityModel: {},
                },
                sorting: {
                    sortModel: [{ field: 'dateCreated', sort: 'desc' }],
                },
            }}
            {...props}
            columns={columns}
        />
    </Box>
);

const columns: GridColDef[] = [
    {
        field: '',
        headerName: 'Edit',
        disableColumnMenu: true,
        sortable: false,
        renderCell: (params) => (
            <IconButton onClick={() => history.push(`${history.location.pathname}/${params.id}`)} size='large'>
                <Icon>edit</Icon>
            </IconButton>
        ),
    },
    {
        field: 'id',
    },
    {
        field: 'active',
        type: 'boolean',
    },
    {
        field: 'remarks',
        flex: 1,
    },
];
